import script from "./MainHome.vue?vue&type=script&setup=true&lang=js"
export * from "./MainHome.vue?vue&type=script&setup=true&lang=js"

import "./MainHome.vue?vue&type=style&index=0&id=6a4a5b30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a4a5b30"]])

export default __exports__